<template>
  <div class="page">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="60%"
      :mask-closable="false"
      :title="$t('house.configEdit')"
      class-name="vertical-center-modal"
    >
      <div class="three-modal">
        <div
          class="three-item"
          :class="{
            mainBack: Number(item.type) === 1,
            sedBack: Number(item.type) === 0,
          }"
          v-for="(item, k) in controlList"
          :key="k"
          @click="edit(item, k)"
        >
          <span class="big-font">{{ item.name }}</span>

          <div class="sm-font">
            <Row class="margin-bottom-10">
              <Col span="6"> </Col>
              <Col span="6" class="text-left">
                <span>{{ $t("house.start") + "：" }}</span>
              </Col>

              <Col span="6" class="text-right no-click">
                <i-switch v-model="item.on" size="large" true-color="#13ce66" />
              </Col>
              <Col span="6"> </Col>
            </Row>
            <Row>
              <Col span="6"> </Col>
              <Col span="6" class="text-left">
                <span>{{ $t("house.see") + "：" }}</span>
              </Col>

              <Col span="6" class="text-right">
                <span>{{
                  item.visible ? $t("house.see") : $t("house.noSee")
                }}</span>
              </Col>
              <Col span="6"> </Col>
            </Row>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="modal-foot-btn">
          <Button
            type="primary"
            size="large"
            class="btn-width"
            ghost
            @click="resetAllList"
            >{{ $t("common.reset") }}</Button
          >
          <Button
            type="primary"
            size="large"
            class="btn-width"
            @click="saveControl"
            >{{ $t("common.save") }}</Button
          >
        </div>
      </div>
    </Modal>

    <div class="content_win">
      <editThreeModal
        ref="editThreeModal"
        @reset="toResetItem(arguments)"
        @delete="toDeleteItem(arguments)"
        @edit="toEditItem(arguments)"
      ></editThreeModal>
    </div>
  </div>
</template>

<script>
import editThreeModal from "./editThreeModal.vue";
export default {
  name: "ModalBox",
  props: {},
  components: {
    editThreeModal,
  },
  data() {
    return {
      dialogVisible: false,
      defalutObj: {
        type: 0, // 主控1 分控0
        name: this.$t("house.sedControl"),
        on: false,
        visible: false,
        belong: null,
      },
      mainObj: {
        type: 1, // 主控1 分控0
        name: this.$t("house.mainControl") + 1,
        on: false,
        visible: false,
        belong: null,
        configList: [
          {
            label: this.$t("house.temp1"),
            key: "Three constant temperature",
            name: "Temperature°：",
            value: 1,
          },
          {
            label: this.$t("house.temp2"),
            key: "Three constant humidity",
            name: "Humidity:",
            value: 1,
          },
          {
            label: "PM2.5",
            key: "Three constant PM2.5",
            name: "PM2.5",
            value: 1,
          },
          {
            label: "CO2",
            key: "Three constant CO2",
            name: "CO2 Gas:",
            value: 1,
          },
          {
            label: "TVOC",
            key: "Three constant TVOC",
            name: "TVOC Gas:",
            value: 1,
          },
          {
            label: this.$t("threeProject.cho"),
            key: "Three constant HCHO",
            name: "HCHO concentration:",
            value: 1,
          },
        ],
      },
      defalutList: JSON.parse(JSON.stringify(this.global.controlList)),
      controlList: JSON.parse(JSON.stringify(this.global.controlList)),
      mainFlag: false,
      sedFlag: false,
    };
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          // 弹窗关闭 清空数据
        }
      },
    },
    controlList: {
      handler() {
        if (this.mainFlag && this.controlList.length < 12) {
          this.sedFlag = false;
        } else if (!this.mainFlag && this.controlList.length < 13) {
          this.sedFlag = false;
        } else {
          this.sedFlag = true;
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.dialogVisible = false;
    },
    edit(item, k) {
      this.$refs.editThreeModal.dialogVisible = true;
      this.$refs.editThreeModal.itemKey = k;
      this.$refs.editThreeModal.addForm = JSON.parse(JSON.stringify(item));
      this.$refs.editThreeModal.addForm.visibleNum =
        item.visible === true ? 1 : 0;
      this.$refs.editThreeModal.configVisible = item.visible;
    },
    toResetItem(e) {
      console.log(e);
      debugger;
      let key = e[1];
      if (Number(e[0].type) === 1) {
        this.controlList[key] = JSON.parse(JSON.stringify(this.mainObj));
      } else if (Number(e[0].type) === 0) {
        this.controlList[key] = JSON.parse(JSON.stringify(this.defalutObj));
        this.controlList[key].name = this.$t("house.sedControl") + key;
      }

      this.$forceUpdate();
    },
    toDeleteItem(e) {
      console.log(e);
      this.controlList.splice(e[1], 1);
      this.$forceUpdate();
      if (Number(e[0].type) === 1) {
        this.mainFlag = true;
      }
    },
    toEditItem(e) {
      console.log(e);
      let item = e[0];
      let key = e[1];
      this.controlList[key] = item;
      this.$forceUpdate();
    },
    resetAllList() {
      debugger;
      this.controlList = [];
      this.controlList = JSON.parse(JSON.stringify(this.defalutList));
      this.controlList[1].name = this.$t("house.sedControl") + 1;
      console.log(this.controlList);
      debugger;
      this.$forceUpdate();
    },
    saveControl() {
      console.log(this.controlList);
      this.$emit("getControl", this.controlList);
      this.closeModal();
    },
  },
};
</script>
